import styled from 'styled-components';
import { Margin } from 'styled-components-spacing';

const StyledMargin = styled(Margin)`
  &:first-child {
    margin-top: 0;
  }
`;

export default StyledMargin;